import { useCallback } from 'react';
import formatAmount from '../worklets/formatAmount';
const useFormatPriceChangeForStockWorklet = (priceChangeSharedValue, originalDataShared) => {
    const formatPriceChangeForStock = useCallback((closePrice) => {
        'worklet';
        if (closePrice !== null && closePrice !== undefined && closePrice !== '' && originalDataShared?.value) {
            const openPrice = originalDataShared.value.closePrices[0];
            const change = Number(closePrice) - openPrice;
            const changePct = (100 * change) / openPrice;
            return `${Math.abs(changePct).toFixed(2)}% (${formatAmount(Math.abs(change), '$')})`;
        }
        if (typeof priceChangeSharedValue.value === 'string')
            return priceChangeSharedValue.value;
        return '';
    }, [priceChangeSharedValue, originalDataShared]);
    return formatPriceChangeForStock;
};
export default useFormatPriceChangeForStockWorklet;
